function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  version: "1.0",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M28.3 255.1v-21.2h14.2v-14.2H28.3v-21.3h14.2v-14.1H28.3V163h14.2v-14.2H28.3v-21.2h14.2V99.2H0v184.3h283.5v-28.4H28.3zm110-41.4l53.7 21.5 76.5-38.3-12.6-25.3-65.2 32.6-52.6-21.1-72.7 30.6 11 26.1 61.9-26.1zM246.2 0c-20.6 0-37.3 16.7-37.3 37.3v74.3c0 20.6 16.7 37.3 37.3 37.3s37.3-16.7 37.3-37.3V37.3c0-20.6-16.8-37.3-37.3-37.3zm16 111.6c0 8.8-7.2 16-16 16-8.3 0-15.1-6.3-16-14.4h14.3V99h-14.4V84.9h14.4V70.7h-14.4V56.5h14.4V42.3h-14.4v-5c0-8.8 7.2-16 16-16s16 7.2 16 16l.1 74.3c-.1 0 0 0 0 0z"
})));